import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import PiecePreview from "../../components/piece/piecePreviews";

import { Helmet } from "react-helmet";
import BookmarkIcon from "../../assets/icons/bookmarkIcon";
import HeartIcon from "../../assets/icons/heartIcon";
import ShareIcon from "../../assets/icons/shareIcon";
import ButtonWithSpeechBubble from "../../components/buttonWithSpeechBubble";
import Loader from "../../components/loader";
import { openNotification } from "../../components/notification";
import Instrumentation from "../../components/piece/instrumentation";
import { openPopUp } from "../../components/popUp";
import { useAppContext } from "../../context/appContext";
import { PieceResponseDTO } from "../../openapi-generated-client/api";
import PurchaseCancelPopUp from "../../pageparts/popup/purchaseCancelPopUp";
import { calculatePriceWithoutStripeFees, formatPrice } from "../../utils/priceUtils";
import { shareLink } from "../../utils/shareUtils";
import { getDomainName, getTxoriaUrl } from "../../utils/urlUtils";
import useWindowDimensions from "../../utils/useWindowDimensions";
import BuyPiecePopUp from "../buyPiecePopUp";
import BuySuccessPopUp from "../buySuccessPopUp";
import ComposerPieceInfoGroup from "./info-group/composerPieceInfoGroup";
import DescriptionPieceInfoGroup from "./info-group/descriptionPieceInfoGroup";
import DownloadsPieceInfoGroup, { downloadScore } from "./info-group/downloadsPieceInfoGroup";
import KeywordsPieceInfoGroup from "./info-group/keywordsPieceInfoGroup";
import PerformancesPieceInfoGroup from "./info-group/performancesPieceInfoGroup";
import PieceInfoGroup from "./info-group/pieceInfoGroup";
import StatsPieceInfoGroup from "./info-group/statsPieceInfoGroup";
import MobilePieceInfoGroups from "./mobilePieceInfoGroups";
import "./singlePiece.css";
import Button from "../../components/button";
import ReportIcon from "../../assets/icons/reportIcon";
import MovementsPieceInfoGroup from "./info-group/movementsPieceInfoGroup";

interface SinglePiecePageProps {
    purchaseSuccess?: boolean;
}

export default function SinglePiecePage(props: SinglePiecePageProps) {

    const navigate = useNavigate();

    const {pieceController, likeController, bookmarkController, isLoggedIn, sessionId} = useAppContext();

    const windowDimensions = useWindowDimensions();

    const {id} = useParams();

    const shareButtonRef = React.createRef<HTMLDivElement>();
    const likeButtonRef = React.createRef<HTMLDivElement>();
    const bookmarkButtonRef = React.createRef<HTMLDivElement>();

    const [mobileNavActive, setMobileNavActive] = useState(0);
    const [downloadLoading, setDownloadLoading] = useState(false);

    const [pieceData, setPieceData] = useState<PieceResponseDTO | undefined>(undefined);

    async function fetchData() {
        if(isNaN(Number(id))) {
            navigate("/error/2");
            return;
        }
        await pieceController.getPiece(Number(id), sessionId).catch((e) => {
            if(e.status == 404) {
                navigate("/error/4");
            }
        }).then((response) => {
            if(response) {
                setPieceData(response.data);
            }
        });
    }

    useEffect(() => {
        fetchData();
    }, [id, pieceController]);

    useEffect(() => {
            if(props.purchaseSuccess != undefined) {
                if(props.purchaseSuccess) {
                    openPopUp(<BuySuccessPopUp refetch={fetchData} pieceId={Number(id)}/>);
                }else {
                    openPopUp(<PurchaseCancelPopUp pieceId={Number(id)}/>);
                }
            }
    }, [props.purchaseSuccess]);

    if(pieceData == undefined) return <Loader/>;


                    var globalInfo = <article className="global-info keep-margin" itemScope itemType="https://schema.org/SheetMusic">
                        <Helmet>
                            <title>{pieceData.title} - {pieceData.composer?.name} | Txoria</title>
                            <meta itemProp="keywords" content={"sheet music, " + Array.from(pieceData.keywords).join(", ")}/>
                            <meta itemProp="description" content={pieceData.description}/>
                        </Helmet>
                        <h1 itemProp="name">{pieceData.title}</h1>
                        <h3 itemProp="author">{pieceData.composer?.name}</h3>
                        <Instrumentation orchestralInstruments={pieceData.orchestralInstruments} instruments={pieceData.instruments}/>
                        <div className="buy">
                            {
                                pieceData.externalScoreLink == undefined ? 
                                <>
                                    <ButtonWithSpeechBubble loading={downloadLoading} disabled={!isLoggedIn && pieceData.price > 0} onClick={() => {
                                    if(pieceData.canDownload) {
                                        if(pieceData.scores.length == 1) {
                                            downloadScore(pieceData.id, 0, pieceData.scores[0].name!, setDownloadLoading, sessionId);
                                        }else {
                                            if(windowDimensions.width < 800) {
                                                setMobileNavActive(3);
                                                document.getElementById("mobile-info-groups")?.scrollIntoView({behavior: "smooth"});  
                                            }else {
                                                document.getElementById("download-section")?.scrollIntoView({behavior: "smooth"});  
                                            }
                                        }
                                    } else {
                                        openPopUp(<BuyPiecePopUp pieceId={pieceData.id}/>);
                                    }
                                }} bubbleText="You need to be logged in to buy a piece">{pieceData.price > 0 ? pieceData.canDownload ? "Download" : "Buy" : "Download"}</ButtonWithSpeechBubble>
                                <h3>{pieceData.price > 0 ? pieceData.canDownload ? <>Bought ({pieceData.price} €)</> : <>{pieceData.price} € <a className="side-info" title="Price if you use your account balance">{formatPrice(calculatePriceWithoutStripeFees(pieceData.price))} €</a></>: <>Free</>}</h3>
                            </>
                            :
                            <>
                            
                                <Button onClick={() => {
                                    window.open(pieceData.externalScoreLink, "_blank")
                                }}>
                                    Visit {getDomainName(pieceData.externalScoreLink)}
                                </Button>
                                <h3>{pieceData.price > 0 ? <>{pieceData.price} €</> : <>Free</>}</h3>
                                
                            </>


                            }
                            
                        </div>
                        <div className="action-buttons">
                            <div ref={likeButtonRef} className="icon" onClick={async () => {
                                if(!isLoggedIn) {
                                    setTimeout(() => {
                                    if(!likeButtonRef || !likeButtonRef.current) return;
                                        openNotification("You need to be logged in to like a piece", {x: likeButtonRef.current?.getBoundingClientRect().x + window.scrollX, y: likeButtonRef.current?.getBoundingClientRect().y + window.scrollY});
                                    }, 100);
                                    return;
                                }
                                await likeController.toggleLike(sessionId, Number(id));
                                fetchData();
                            }}>
                                <a>{pieceData.likes}</a>
                                <HeartIcon filled={pieceData.hasLiked}/>
                            </div>
                            <div ref={bookmarkButtonRef} className="icon" onClick={async () => {
                                if(!isLoggedIn) {
                                    setTimeout(() => {
                                    if(!bookmarkButtonRef || !bookmarkButtonRef.current) return;
                                        openNotification("You need to be logged in to bookmark a piece", {x: bookmarkButtonRef.current?.getBoundingClientRect().x + window.scrollX, y: bookmarkButtonRef.current?.getBoundingClientRect().y + window.scrollY});
                                    }, 100);
                                    return;
                                }
                                if(pieceData.hasBookmarked) {
                                    await bookmarkController.removeBookmark(sessionId, Number(id));
                                }else {
                                    await bookmarkController.addBookmark(sessionId, Number(id));
                                }
                                fetchData();
                            }}>
                                <BookmarkIcon filled={pieceData.hasBookmarked}/>
                            </div>
                            <div className="icon" onClick={() => {
                                navigate("/pieces/" + pieceData.id + "/report");
                            }}>
                                <ReportIcon/>
                            </div>
                            <div ref={shareButtonRef} className="icon" onClick={() => {
                                if (!shareButtonRef.current) return;
                                const rect = shareButtonRef.current.getBoundingClientRect();
                                shareLink(
                                    getTxoriaUrl() + "pieces/" + pieceData.id,
                                    pieceData.title,
                                    "Check out this piece on Txoria.org composed by " + pieceData.composer.name + "!",
                                    rect.x + window.scrollX,
                                    rect.y + window.scrollY
                                );
                            }}>
                                <ShareIcon/>
                            </div>
                        </div>
                    </article>;
    
    if(windowDimensions.width < 800) {
        return <div className="page single-piece mobile">
            <PiecePreview fixedAspectRatio={350/450} thumbnailHash={pieceData.thumbnailHash} previewHash={pieceData.previewHash ? pieceData.previewHash : pieceData.thumbnailHash}/>
            {globalInfo}
            <MobilePieceInfoGroups id="mobile-info-groups" active={mobileNavActive} setActive={setMobileNavActive} canDownload={pieceData.canDownload} piece={pieceData}/>
        </div>;
    }else if(windowDimensions.width < 1050) {
        return <div className="page single-piece mobile">
            <div className="left-section">
                <PiecePreview fixedAspectRatio={350/450} thumbnailHash={pieceData.thumbnailHash} previewHash={pieceData.previewHash ? pieceData.previewHash : pieceData.thumbnailHash}/>
                {globalInfo}
                <PieceInfoGroup><StatsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup><KeywordsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup><DescriptionPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup><ComposerPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup id="download-section" fullWidth><DownloadsPieceInfoGroup sessionId={sessionId} canDownload={pieceData.canDownload} piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup><PerformancesPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
                <PieceInfoGroup><MovementsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
            </div>
        </div>;
    }


    return <div className="page single-piece">
        <div className="left-section">
            <PiecePreview thumbnailHash={pieceData.thumbnailHash} previewHash={pieceData.previewHash ? pieceData.previewHash : pieceData.thumbnailHash}/>

            <PieceInfoGroup><StatsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
            <PieceInfoGroup><KeywordsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
            <PieceInfoGroup><DescriptionPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
            <PieceInfoGroup><ComposerPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
        </div>
        <div className="right-section">
            {globalInfo}
            <PieceInfoGroup id="download-section" fullWidth><DownloadsPieceInfoGroup sessionId={sessionId} canDownload={pieceData.canDownload} piece={pieceData}/></PieceInfoGroup>
            <PieceInfoGroup><PerformancesPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
            <PieceInfoGroup><MovementsPieceInfoGroup piece={pieceData}/></PieceInfoGroup>
        </div>
    </div>;
}